import userHasPermission from '@/helpers/userHasPermission'
import permissions from '@/constants/permissions'
import hasActionStatus from '@/helpers/hasActionStatus'
import CHILD_STATUS from '@/constants/childStatus'
import type { ApiPermissionsFlags } from '@/types'
// @TODO: maybe we can make this helper a childActions store ?

const publishStatuses = [CHILD_STATUS.documentAccepted, CHILD_STATUS.withdrawnFromChildChoicePath]
const assignVolunteerStatuses = [
  CHILD_STATUS.documentAccepted,
  CHILD_STATUS.included,
  CHILD_STATUS.withdrawnFromChildChoicePath
]
const canChangeSchoolStatuses = [
  CHILD_STATUS.new,
  CHILD_STATUS.documentsBeingChecked,
  CHILD_STATUS.documentAccepted,
  CHILD_STATUS.withdrawnFromChildChoicePath
]
const revokePublishStatuses = [CHILD_STATUS.included]
const canUpdateChildBaseDataStatuses = [
  CHILD_STATUS.new,
  CHILD_STATUS.documentsBeingChecked,
  CHILD_STATUS.documentAccepted,
  CHILD_STATUS.withdrawnFromChildChoicePath
]
const canExcludeChildStatuses = [
  CHILD_STATUS.new,
  CHILD_STATUS.documentsBeingChecked,
  CHILD_STATUS.documentAccepted,
  CHILD_STATUS.withdrawnFromChildChoicePath
]
const canIncludeAgainChildStatuses = [CHILD_STATUS.excluded]
const canViewDonorSectionStatuses = [
  CHILD_STATUS.included,
  CHILD_STATUS.withdrawnFromChildChoicePath
]

const canViewSummariesSectionStatuses = [
  CHILD_STATUS.included,
  CHILD_STATUS.documentAccepted,
  CHILD_STATUS.withdrawnFromChildChoicePath
]

export const apiPermissionsFlags = () =>
  ({
    getAssignedFlag: userHasPermission(permissions.assignedChildEditionView),
    getAssignedFirst:
      userHasPermission(permissions.assignedChildEditionView) &&
      !userHasPermission(permissions.childEditionView),
    getIsCoordinator: userHasPermission(permissions.coordinatorChildEditionDetailsView)
  }) as const satisfies ApiPermissionsFlags

export const canViewFootprint = () =>
  userHasPermission(permissions.summaryCorrecting) ||
  userHasPermission(permissions.successCardCorrecting)

export default (status = { id: -1 }, beforeExclusionStatus = { id: -1 }, route = 'ChildCard') => ({
  apiPermissionsFlags,
  canPublish:
    userHasPermission(permissions.childEditionPublish) &&
    hasActionStatus(publishStatuses, status?.id) &&
    route !== 'CoordinatorsChildCard',
  canAssignVolunteer:
    userHasPermission(permissions.volunteerAssign) &&
    hasActionStatus(assignVolunteerStatuses, status?.id) &&
    !['CoordinatorsChildCard', 'CoordinatorsChildrenList'].includes(route),
  canChangeSchool:
    userHasPermission(permissions.childEditionChangeWioStruct) &&
    hasActionStatus(canChangeSchoolStatuses, status?.id) &&
    route !== 'CoordinatorsChildCard',
  canRevokePublication:
    userHasPermission(permissions.childEditionRevokePublication) &&
    hasActionStatus(revokePublishStatuses, status?.id) &&
    route !== 'CoordinatorsChildCard',
  canUpdateChildBaseData:
    userHasPermission(permissions.childEditionUpdate) &&
    hasActionStatus(canUpdateChildBaseDataStatuses, status?.id) &&
    route !== 'CoordinatorsChildCard',
  canExcludeChild:
    userHasPermission(permissions.childEditionExclude) &&
    hasActionStatus(canExcludeChildStatuses, status?.id) &&
    route !== 'CoordinatorsChildCard',
  canIncludeAgainChild:
    userHasPermission(permissions.childEditionIncludeAgain) &&
    hasActionStatus(canIncludeAgainChildStatuses, status?.id) &&
    route !== 'CoordinatorsChildCard',
  canViewDonorSection:
    route !== 'CoordinatorsChildCard' &&
    (hasActionStatus(canViewDonorSectionStatuses, status?.id) ||
      (hasActionStatus([CHILD_STATUS.excluded], status?.id) &&
        hasActionStatus(canViewDonorSectionStatuses, beforeExclusionStatus?.id))),
  canViewPaymentsList:
    userHasPermission(permissions.paymentAccess) && route !== 'CoordinatorsChildCard',
  canViewChangelog: route !== 'CoordinatorsChildCard',
  canViewSuccessCards:
    route !== 'CoordinatorsChildCard' &&
    (status?.id !== CHILD_STATUS.excluded ||
      hasActionStatus(
        [CHILD_STATUS.documentAccepted, CHILD_STATUS.withdrawnFromChildChoicePath],
        beforeExclusionStatus?.id
      )),
  canViewDonorContacts: route !== 'CoordinatorsChildCard',
  isSummariesVisible:
    hasActionStatus(canViewSummariesSectionStatuses, status?.id) ||
    (status?.id === CHILD_STATUS.excluded &&
      hasActionStatus(canViewSummariesSectionStatuses, beforeExclusionStatus?.id)),
  hasPermissionToViewRecommendations:
    userHasPermission(permissions.nextEditionRecommendationView) ||
    userHasPermission(permissions.nextEditionRecommendationViewCoordinator)
})
